import React, { type FC } from "react";
import styles from "./AvailabilityBadges.module.scss";
import { useCommonOptionalLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import Incentive from "../molecules/Incentive";

type AvailabilityBadgesProps = {
    isSoldOut?: boolean;
    isAvailableForOnlineSales?: boolean;
    isLimitedStock?: boolean;
};

const AvailabilityBadges: FC<AvailabilityBadgesProps> = (props) => {
    const { isSoldOut, isAvailableForOnlineSales, isLimitedStock } = props;

    const [soldOutLabel, availableForOnlineSaleLabel, limitedStockLabel] = useCommonOptionalLabel([
        "soldOut",
        "availableForOnlineSale",
        "limitedStock",
    ]);

    const showIsSoldOut = isSoldOut && soldOutLabel;
    const showIsLimitedStock = isLimitedStock && limitedStockLabel;
    const showIsAvailableForOnlineSales = isAvailableForOnlineSales && availableForOnlineSaleLabel;

    if (!showIsSoldOut && !showIsAvailableForOnlineSales && !showIsLimitedStock) {
        return null;
    }

    return (
        <ul role="list" className={styles.list}>
            {showIsLimitedStock ? (
                <li>
                    <Incentive label={limitedStockLabel} variant="limited-stock" />
                </li>
            ) : showIsSoldOut ? (
                <li>
                    <Incentive label={soldOutLabel} variant="sold-out" />
                </li>
            ) : (
                showIsAvailableForOnlineSales && (
                    <li>
                        <Incentive label={availableForOnlineSaleLabel} variant="available-for-online-sales" />
                    </li>
                )
            )}
        </ul>
    );
};

export default AvailabilityBadges;
